export const K_RATE = 'k-rate';
export const A_RATE = 'a-rate';
